import {
  UPDATE_FILTER_OPTIONS,
} from '../constants';

export const updateFilterOptions = (filterOptions) => {
  return {
    type: UPDATE_FILTER_OPTIONS,
    filterOptions
  }
}


// WEBPACK FOOTER //
// ./src/reports/general/javascripts/actions/filterOptionActions.js